import { FC, ReactElement } from 'react';

import { Box } from '@mui/material';
import { DetailViewTab } from 'portfolio3/containers/drawers/DetailViewDrawer/types';

import { findChildComponentByType } from '../../../../utils';
import FilesTab, { IFilesTabProps } from '../tabs/Files';
import GeneralInfoTab, { IGeneralInfoTabProps } from '../tabs/GeneralInfo';
import LinkedObjectsTab, { ILinkedObjectsTabProps } from '../tabs/LinkedObjects';
import ResultsTab, { IResultsTabProps } from '../tabs/Results';
import * as styles from './styles';

interface IPortfolioEntityCardProps {
  currentTab: DetailViewTab;
  children?: (
    | ReactElement<IGeneralInfoTabProps | IFilesTabProps | ILinkedObjectsTabProps | IResultsTabProps>
    | boolean
  )[];
}

interface IPortfolioEntityCardPropsSubcomponents {
  GeneralInfoTab: FC<IGeneralInfoTabProps>;
  FilesTab: FC<IFilesTabProps>;
  LinkedObjectsTab: FC<ILinkedObjectsTabProps>;
  ResultsTab: FC<IResultsTabProps>;
}

const PortfolioEntityCard: FC<IPortfolioEntityCardProps> & IPortfolioEntityCardPropsSubcomponents = ({
  currentTab,
  children,
}) => {
  const GeneralInfoTab = findChildComponentByType(children, PortfolioEntityCard.GeneralInfoTab);
  const FilesTab = findChildComponentByType(children, PortfolioEntityCard.FilesTab);
  const LinkedObjectsTab = findChildComponentByType(children, PortfolioEntityCard.LinkedObjectsTab);
  const ResultsTab = findChildComponentByType(children, PortfolioEntityCard.ResultsTab);

  return (
    <Box className="entity-card" sx={styles.root}>
      {currentTab === DetailViewTab.RESULTS && ResultsTab}
      {currentTab === DetailViewTab.GENERAL && GeneralInfoTab}
      {currentTab === DetailViewTab.FILES && FilesTab}
      {currentTab === DetailViewTab.LINKED_OBJECTS && LinkedObjectsTab}
    </Box>
  );
};

PortfolioEntityCard.GeneralInfoTab = GeneralInfoTab;
PortfolioEntityCard.FilesTab = FilesTab;
PortfolioEntityCard.LinkedObjectsTab = LinkedObjectsTab;
PortfolioEntityCard.ResultsTab = ResultsTab;

export default PortfolioEntityCard;
